module.exports = __webpack_public_path__ + "static/why-hassle.60742b05.jpg";